export const dataURLtoFile = (dataurl, filename) => {
    const arr = dataurl.split(',');
    const mime = arr[0].match(/:(.*?);/)[1];
    const bstr = atob(arr[1]);
    let n = bstr.length;
    const u8arr = new Uint8Array(n);

    while (n--) {
        u8arr[n] = bstr.charCodeAt(n);
    }

    return new File([u8arr], filename, { type: mime });
};

export const shareContent = async (title, text, url) => {
    if (navigator.share) {
        try {
            await navigator.share({
                title,
                text,
                url
            });
            return true;
        } catch (error) {
            console.error('Error sharing content:', error);
            return false;
        }
    } else {
        alert(`Share this link: ${url}`);
        return false;
    }
};


export const validateMobileNumber = (number) => {
    const numericOnly = number.replace(/\D/g, '');

    return numericOnly.length >= 5 && numericOnly.length <= 12;
};

export const validateEmail = (email) => {
    const value = (email || '').trim();
    if (!value) return false;

    return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(value);
};

export const validateName = (name) => {
    return name && name.trim().length >= 2;
};

export const debounce = (func, delay) => {
    let timer;
    return function(...args) {
        clearTimeout(timer);
        timer = setTimeout(() => {
            func.apply(this, args);
        }, delay);
    };
};

export const generateSecurePin = () => {
    return Math.floor(1000 + Math.random() * 9000).toString();
};

export const formatDateTime = (dateString) => {
    const options = {
        year: 'numeric',
        month: 'short',
        day: 'numeric',
        hour: '2-digit',
        minute: '2-digit'
    };
    return new Date(dateString).toLocaleDateString(undefined, options);
};

export const hasCamera = async () => {
    try {
        const devices = await navigator.mediaDevices.enumerateDevices();
        return devices.some(device => device.kind === 'videoinput');
    } catch (error) {
        console.error('Error checking for camera:', error);
        return false;
    }
};

export const handleApiError = (error, fallbackMessage = 'An error occurred') => {
    console.error(error);
    const errorMessage = error.message || fallbackMessage;
    return errorMessage;
};

export const truncateText = (text, maxLength = 50) => {
    if (!text || text.length <= maxLength) return text;
    return text.substring(0, maxLength).trim() + '...';
};

export const delay = (ms) => new Promise(resolve => setTimeout(resolve, ms));

export const getFileExtension = (filename) => {
    return filename.slice((filename.lastIndexOf('.') - 1 >>> 0) + 2);
};

export const generateUniqueFilename = (prefix, extension) => {
    const timestamp = new Date().getTime();
    const random = Math.floor(Math.random() * 1000);
    return `${prefix}-${timestamp}-${random}.${extension}`;
};

export const isMobileDevice = () => {
    return /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent);
};

export default {
    dataURLtoFile,
    shareContent,
    validateMobileNumber,
    validateEmail,
    validateName,
    debounce,
    generateSecurePin,
    formatDateTime,
    hasCamera,
    handleApiError,
    truncateText,
    delay,
    getFileExtension,
    generateUniqueFilename,
    isMobileDevice
};
